import * as React from 'react';
import { ValidationProps, ValidationLevel, ValidationMessage } from './types';

import styles from './validation.scss';
import get from 'lodash/get';

export const getValidationStyle = level => level === ValidationLevel.error
  ? 'danger'
  : ValidationLevel[level];

export class Validation extends React.PureComponent<ValidationProps>{

  public render() {

    const multilineMessages = this.props.enableMultilineValidation ? styles.multilineValidation : '';

    return (
      <div className={styles.messageWrapper}>
        <div className={styles.warningIcon} />
        {Array.isArray(this.props.messages) &&
          <ul className={styles.messages}>
            {this.props.messages
              .reduce((result, message) =>
                result.some(existing => existing.level === message.level &&
                  existing.message === message.message)
                  ? result
                  : [
                    ...result,
                    message
                  ], [] as ValidationMessage[])
              .map((item, index) => (
                <li key={index} className={`${multilineMessages} ${!!item.level && 'list-group-item-' + getValidationStyle(item.level)}`}>
                  {item.message}
                </li>))}
          </ul>
        }
      </div>
    );
  }
}

/**
 * Renders a validation summary panel, with one or multiple sets of validation errors
 * This is not the same as rendering <Validation/>, as this one wraps everything in a panel
 *
 * @param props 
 */
export const ValidationSummary: React.FC<{ validationError?: ValidationProps; validationErrors?: ValidationProps[] }> = props => {

  return get(props.validationError, 'messages.length') || get(props.validationErrors, 'length') ?
    <div>
      {props.validationErrors && props.validationErrors.map(validationError =>
        <div className={`alert-${validationError.level} ${styles.validationSummary} validationsummary`}>
          {
            <Validation {...validationError} />
          }
        </div>)
      }

      {props.validationError && <div className={`alert-${getValidationStyle(props.validationError.level)} 
        ${styles.validationSummary} validationsummary`}>
        {
          <Validation {...props.validationError} />
        }
      </div>
      }
    </div> : null;
};
